import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {QuotationsService} from "../../data/quotations.service";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'quotation-cancel',
  templateUrl: './quotation-cancel.component.html',
  styleUrls: ['./quotation-cancel.component.scss']
})
export class QuotationCancelComponent implements OnInit {
  form: FormGroup;

  constructor(
      private formBuilder: FormBuilder,
      private QuotationsService: QuotationsService
  ) { }

  @Input() quotation_revision_id: number;
  @Input() quotationNumber: string;

  @Output() onClose=new EventEmitter();
  @Output() onSuccess=new EventEmitter();

  ngOnInit(): void {
    this.addControls();
  }
  addControls() {
    this.form = this.formBuilder.group(
        {
          comments: new FormControl('' ),
        }
    );
  }
  get formControls() {
    return this.form.controls;
  }
  save() {
    let data={
      quotation_revision_id: this.quotation_revision_id,
      comments: this.formControls.comments.value
    }
    this.QuotationsService.cancel(data).subscribe(
        ()=>{},
        (error)=>console.error(error),
        ()=>this.onSuccess.emit()
    )
  }
  close() {
    this.onClose.emit();
  }
}
